module.exports = __webpack_public_path__ + "static/media/logo-vertical.3b97f514.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/logo-vertical.svg
// module id = 885
// module chunks = 0